import { createRequest } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import * as modern from "./modern"

const changeFleetForModernPolicies = async (input: modern.ChangeFleetModernInput, getToken: () => Promise<string>) => {
  await modern.changeFleetModern(input, getToken)
}

const changeFleetModern = createRequest<modern.ChangeFleetModernInput, void>(async (input, getToken) =>
  changeFleetForModernPolicies(input, getToken)
)

export const useChangeFleetModern = createRequestHook(changeFleetModern)
